
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seller/event",
      function () {
        return require("private-next-pages/seller/event.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seller/event"])
      });
    }
  